import { Box, Paper, styled, SvgIcon, Typography } from "@mui/material";

import { withDefaultProps } from "fond/utils/withDefaultProps";

export const Container = styled(Paper)(({ theme }) => ({
  height: 36,
  width: "100%",
  padding: theme.spacing(2),
}));

export const StyledBox = styled(Box)({
  height: "100%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
});

const SubTitle2 = withDefaultProps(Typography, { variant: "subtitle2" });
export const StyledText = styled(SubTitle2)(({ theme }) => ({
  fontSize: theme.typography.size.small,
  paddingRight: theme.spacing(0.5),
}));

export const StyledIcon = styled(SvgIcon)(({ theme }) => ({
  fontSize: "0.85rem",
  marginRight: theme.spacing(1),
}));
